document.addEventListener('DOMContentLoaded', () => {
  const filterContainer = document.getElementById('update-filters');
  if (!filterContainer) return;

  const filterButtons = filterContainer.querySelectorAll('.filter-button');
  const updateItems = document.querySelectorAll('.update-item');
  const monthGroups = document.querySelectorAll('.month-group');

  const HIGHLIGHT_CLASS = 'text-cake-blue';

  const updateActiveMonthOnScroll = () => {
    const allMonthSpans = document.querySelectorAll('.updates-month');

    const triggerPoint = window.innerHeight * 0.8;

    let bestCandidate = null;

    allMonthSpans.forEach(span => {
      const container = span.closest('.month-group > div:first-child');
      if (container && container.classList.contains('hidden')) {
        return;
      }

      const rect = span.getBoundingClientRect();

      if (rect.top <= triggerPoint) {
        bestCandidate = span;
      }
    });

    if (!bestCandidate) {
      bestCandidate = Array.from(allMonthSpans).find(span => {
        const container = span.closest('.month-group > div:first-child');
        return container && !container.classList.contains('hidden');
      });
    }

    allMonthSpans.forEach(span => {
      span.classList.remove(HIGHLIGHT_CLASS);
    });

    if (bestCandidate) {
      bestCandidate.classList.add(HIGHLIGHT_CLASS);
    }
  };

  const filterUpdates = (filterValue) => {
    const normalizedFilter = filterValue.toLowerCase();

    document.querySelectorAll('h2 > a').forEach(el => {
      el.classList.remove(HIGHLIGHT_CLASS);
    });

    let latestDate = 0;
    let latestPostLink = null;

    updateItems.forEach((item) => {
      const itemProduct = item.dataset.product.toLowerCase();
      const isVisible = normalizedFilter === 'all' || itemProduct === normalizedFilter;

      if (isVisible) {
        item.classList.remove('hidden');
        const itemDate = parseInt(item.dataset.postDate, 10);

        if (itemDate > latestDate) {
          latestDate = itemDate;
          latestPostLink = item.querySelector('h2 > a');
        }
      } else {
        item.classList.add('hidden');
      }
    });

    monthGroups.forEach((group) => {
      const itemsInGroup = group.querySelectorAll('.update-item');
      const hasVisibleItem = Array.from(itemsInGroup).some(
        (item) => !item.classList.contains('hidden'),
      );
      const monthSpanContainer = group.children[0];
      const updatesContainer = group.children[1];

      if (!hasVisibleItem) {
        monthSpanContainer.classList.add('hidden');
        updatesContainer.classList.add('hidden');
      } else {
        monthSpanContainer.classList.remove('hidden');
        updatesContainer.classList.remove('hidden');
      }
    });

    if (latestPostLink) {
      latestPostLink.classList.add(HIGHLIGHT_CLASS);
    }
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const filterValue = button.dataset.filter;

      filterButtons.forEach((btn) => {
        btn.classList.remove('active', 'bg-gray-900', HIGHLIGHT_CLASS, 'border', 'border-cake-blue', 'bg-white');
        btn.classList.add('text-gray-700', 'hover:bg-gray-200');
      });

      button.classList.add('active', 'bg-gray-900', HIGHLIGHT_CLASS, 'border', 'border-cake-blue', 'bg-white');
      button.classList.remove('text-gray-700', 'hover:bg-gray-200');

      filterUpdates(filterValue);

      setTimeout(updateActiveMonthOnScroll, 50);
    });
  });


  let scrollTimeout;
  window.addEventListener('scroll', () => {
    if (scrollTimeout) return;

    scrollTimeout = setTimeout(() => {
      updateActiveMonthOnScroll();
      scrollTimeout = null;
    }, 100);
  });

  filterUpdates('all');
  updateActiveMonthOnScroll();
});